import { Component, Inject, Input, OnInit } from '@angular/core';
import {
  MatBottomSheetRef,
  MAT_BOTTOM_SHEET_DATA,
} from '@angular/material/bottom-sheet';
import { MatDialog } from '@angular/material/dialog';
import { ArrivalStatus } from '../../../../data/models/enum/arrival/arrival-status.enum';
import { ImageType } from '../../../../data/models/enum/arrival/authorized-responsable/image-type.enum';
import { TypeUser } from '../../../../data/models/enum/arrival/authorized-responsable/type-image-user';
import {
  currentMessage,
  statusDescription,
  userMessage,
} from '../../../../data/utils/arrival/monitoring-message.utils';
import { CardArrivalDetail } from '../../../../../app/data/models/dto/arrival/card-arrival-detail';
import { CloseImageComponent } from '../close-image/close-image.component';
import { buildShowImageDialog } from 'src/app/data/factory/authorization.factory';
import { AUTHORIZED_USER } from 'src/app/ui/constants/arrival/gate-monitoring';
import { AuthorizationType } from 'src/app/data/models/enum/arrival/authorization-type.enum';

@Component({
  selector: 'app-arrival-detail-status',
  templateUrl: './arrival-detail-status.component.html',
  styleUrls: ['./arrival-detail-status.component.scss'],
})
export class ArrivalDetailStatusComponent implements OnInit {
  classModalDialog: string = '';
  dateStr: string = '';
  imageOpened: boolean = false;

  cardArrivalDetail: CardArrivalDetail | undefined;

  imgPhoto: string | undefined;

  constructor(
    public imageDialog: MatDialog,
    private _bottomSheetRef: MatBottomSheetRef<ArrivalDetailStatusComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: CardArrivalDetail
  ) {
    this.cardArrivalDetail = {
      idArrival: data.idArrival,
      dtArrival: data.dtArrival,
      statusArrival: data.statusArrival,
      isResponsable: data.isResponsable,
      responsable: data.responsable,
      authorized: data.authorized,
      authorizedProfiles: data.authorizedProfiles,
      history: data.history,
      authorizationType: data.authorizationType,
    };
  }

  fillDate(dtArrival?: Date): string {
    const currentDate = new Date();
    currentDate.setUTCHours(0, 0, 0, 0);
    const date = dtArrival ? new Date(dtArrival) : null;
    date?.setUTCHours(0, 0, 0, 0);
    return currentDate.getDate() === date?.getDate() ? 'Hoje' : '';
  }

  ngOnInit(): void {
    this.imgPhoto = this.buildImage(this.cardArrivalDetail!);
    this.classModalDialog =
      this.cardArrivalDetail?.authorized?.photo.type == ImageType.PROFILE
        ? 'show-image-box-container'
        : '';
  }

  buildImage(details: CardArrivalDetail): string {
    return details?.isResponsable
      ? details?.responsable?.photo
        ? details?.responsable?.photo.paths[0]
          ? details?.responsable?.photo.paths[0]
          : `https://ui-avatars.com/api/?size=512&name=${details?.responsable?.name}`
        : `https://ui-avatars.com/api/?size=512&name=${details?.responsable?.name}`
      : details?.authorized?.photo
      ? details?.authorized?.photo.paths[0]
        ? details?.authorized?.photo.paths[0]
        : `https://ui-avatars.com/api/?size=512&name=${details?.authorized?.name}`
      : `https://ui-avatars.com/api/?size=512&name=${details?.authorized?.name}`;
  }

  sendMessageArrowDirection(status: ArrivalStatus): boolean {
    return status === ArrivalStatus.RELEASED ? true : false;
  }

  statusDescription(
    status: ArrivalStatus,
    message: string,
    responsable: boolean,
    oldStatus?: ArrivalStatus,
    authorizationType?: AuthorizationType
  ) {
    return responsable
      ? statusDescription(status, message, oldStatus, responsable)
      : authorizationType?.toString() ==
        AuthorizationType[AuthorizationType.PERMANENT]
      ? AUTHORIZED_USER.PERMANENT
      : AUTHORIZED_USER.TEMPORARY;
  }

  userMessage(message: string) {
    return userMessage(message);
  }

  currentMessage(status: ArrivalStatus, responsable?: boolean): string {
    return responsable === false
      ? AUTHORIZED_USER.STATUS_ARRIVED
      : currentMessage(status);
  }

  close(action: string) {
    if (action.includes('close-component') && this.imageOpened === false) {
      this._bottomSheetRef.dismiss();
    }
  }

  showImage(action: string) {
    this.imageOpened = true;
    if (action.includes('close-image')) {
      this.showImageDialog();
    }
  }

  isCurrantDay(dtArrival?: Date): boolean {
    return dtArrival &&
      new Date(dtArrival).setHours(0, 0, 0, 0) ==
        new Date().setHours(0, 0, 0, 0)
      ? true
      : false;
  }

  showImageDialog() {
    const authorizationDataPhoto = this.cardArrivalDetail?.isResponsable
      ? this.cardArrivalDetail?.responsable!
      : this.cardArrivalDetail?.authorized!;
    const typeUser = this.cardArrivalDetail!.isResponsable
      ? TypeUser.RESPONSIBLE
      : TypeUser.AUTHORIZED;
    this.classModalDialog =
      this.cardArrivalDetail?.isResponsable ||
      this.cardArrivalDetail?.authorized?.photo == null ||
      this.cardArrivalDetail?.authorized?.photo.type == ImageType.PROFILE
        ? 'show-image-box-container'
        : 'show-document-box-container';
    const dialogRef = this.imageDialog.open(CloseImageComponent, {
      data: buildShowImageDialog(authorizationDataPhoto, typeUser),
      maxWidth: '300px',
      maxHeight: '400px',
      panelClass: this.classModalDialog,
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.imageOpened = false;
    });
  }
}
